module.exports = __webpack_public_path__ + "img/main-bg.fa3387e3.png";